// extracted by mini-css-extract-plugin
export default {"container":"bra_1wC0e"};